export interface FormSubmitResult {
  success: boolean;
  message: string;
}

/**
 * Generic form submission handler.
 * TODO: Replace the implementation with a real backend, EmailJS, or Web3Forms
 * when the backend is ready. The function signature is stable and can be kept as-is.
 */
export async function submitForm(
  formData: Record<string, string>,
  formType: string
): Promise<FormSubmitResult> {
  // Simulate async processing
  await new Promise((resolve) => setTimeout(resolve, 600));
  console.info(`[Form] Submitted (${formType}):`, formData);
  return {
    success: true,
    message: 'Talebiniz alındı! En kısa sürede sizinle iletişime geçeceğiz.',
  };
}
